import { getDocument } from './general';
var getCookie = function (name, cookieStr) {
    if (name === void 0) { name = ''; }
    if (cookieStr === void 0) { cookieStr = ''; }
    var nameEQ = "".concat(name, "=");
    var cookies = cookieStr.split(';');
    for (var i = 0; i < cookies.length; i += 1) {
        var cookie = cookies[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1, cookie.length);
        }
        if (cookie.indexOf(nameEQ) === 0) {
            return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    return '';
};
/**
 * Reads the SAS cookie and decodes it
 */
var decodeSASCookie = function () {
    var sasCookieVal = getCookie('THD_SAS');
    if (sasCookieVal) {
        sasCookieVal = sasCookieVal.replace(/"/g, '');
        return JSON.parse(atob(sasCookieVal));
    }
    return null;
};
/**
 * Getting the device ID from SAS
 */
export var getDeviceIdFromSAS = function () {
    var sasCookieVal = decodeSASCookie();
    if (sasCookieVal) {
        return sasCookieVal.deviceId;
    }
    return null;
};
/**
 * Getting the IAM token from SAS
 */
export var getNinetyDayTokenFromSAS = function () {
    var sasCookieVal = decodeSASCookie();
    if (sasCookieVal) {
        return sasCookieVal.ninetyDayToken;
    }
    return null;
};
/**
 * Checks if a cookie exists with the specified key.
 *
 * @param {string} key - The name of the cookie to check.
 * @returns {boolean} Value of cookie, otherwise undefined if cookie does not exist
 */
export var getCookieValue = function (key) {
    var _a, _b;
    if (!key)
        return undefined;
    var cookies = (_a = getDocument()) === null || _a === void 0 ? void 0 : _a.cookie.split(';');
    // Use the find method to check if any cookie starts with the given name
    var cookie = cookies === null || cookies === void 0 ? void 0 : cookies.find(function (cookieVal) {
        var trimmedCookie = cookieVal.trim();
        return trimmedCookie.startsWith("".concat(key, "="));
    });
    if (cookie) {
        // Extract the value after the '=' character
        var value = (_b = cookie === null || cookie === void 0 ? void 0 : cookie.split('=')) === null || _b === void 0 ? void 0 : _b[1];
        return value.trim();
    }
    return undefined;
};
/**
 * Checks if a cookie exists with the specified key.
 *
 * @param {string} key - The name of the cookie to check.
 * @returns {string | undefined} Value of cookie, otherwise undefined if cookie does not exist
 */
export var isCookieEnabled = function (key) {
    var validTrueInput = new Set(['true', '1']);
    var validFalseInput = new Set(['false', '0']);
    try {
        var cookieValue = getCookieValue(key);
        if (cookieValue === undefined)
            return false;
        if (validTrueInput.has(cookieValue))
            return true;
        if (validFalseInput.has(cookieValue))
            return false;
    }
    catch (err) {
        return false;
    }
    return false;
};
